<script>
    import "./bannerSlider.css";
    let logoBanner = "./images/banner-logo.png";
    let bannerImage = "./images/banner.png";
</script>
<div class="container">
<div class="flex items-center">
    <div class="slide-width">
        <img src={logoBanner} alt="logoBanner"/>
        <p>The Karmaverse is a metaverse gaming platform incorporating a number of different Play-to-Earn titles that players will have access to. Produced by Karma Games, these will include different game worlds such as a Zombie Apocalypse Survival, Old West World, and more, all with their unique art style, history, narrative, characters, music and maps. </p>
        <a href="#" class="view-more-btn">VIEW MORE</a>
    </div>
    <div class="slide-width">
        <img style="width: 100%" src={bannerImage} alt="logoBanner"/>
    </div>
</div>
</div>